// src/components/CarBooking/Catalogos/Solicitantes/SolicitantesTabs.jsx
import { useState } from 'react';
import SolicitantesUnidadesOrgTab from '../../Tabs/SolicitantesUnidadesOrgTab';

const tabsList = [
    { key: 'unidadesOrg', label: 'Unidades Organizacionales' },
    // Agregar más tabs aquí si es necesario
];

export default function SolicitantesTabs({ solicitanteId }) {
    const [active, setActive] = useState('unidadesOrg');
    const hasValidContext = Number(solicitanteId || 0) > 0;

    if (!hasValidContext) {
        return (
            <div className="person-tabs-disabled">
                <span>
                    Selecciona o crea un solicitante y pulsa <b>Editar</b> para gestionar sus datos
                    relacionados.
                </span>
            </div>
        );
    }

    return (
        <div className="person-tabs-wrap">
            <div className="person-tabs-bar">
                {tabsList.map((t) => (
                    <button
                        key={t.key}
                        className={`person-tab ${active === t.key ? 'is-active' : ''}`}
                        onClick={() => setActive(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="person-tab-panel">
                {active === 'unidadesOrg' && <SolicitantesUnidadesOrgTab fkValue={solicitanteId} />}
            </div>
        </div>
    );
}
